import { useState, useCallback } from 'react'
import { isEmpty } from 'lodash'

import { Dialog, DialogContent, IconButton, DialogActions } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'

import { ModalDashboardLayoutContent } from '../../../dis/dashboard/Dashboard'

export function useModalDashboardDialog(props) {
	const { parentModalDashboardSetting } = props
	const [open, setOpen] = useState(false)
	const [passedIdValue, setPassedIdValue] = useState(null)
	const [modalDashboardSetting, setModalDashboardSetting] = useState(null)

	// Open the dialog with specific props
	const handleOpenModalDashboardDialog = useCallback(
		({ passedIdValue, modalDashboardSetting }) => {
			setPassedIdValue(passedIdValue)
			setModalDashboardSetting(modalDashboardSetting)
			setOpen(true)
		},
		[passedIdValue, modalDashboardSetting]
	)

	// Close the dialog
	const handleCloseModalDashboardDialog = useCallback(() => {
		setOpen(false)
	}, [])

	// Reset all state
	const resetDialog = useCallback(() => {
		setOpen(false)
		setPassedIdValue(null)
		setModalDashboardSetting(null)
	}, [])

	// Memoize the dialog JSX so it only re-renders when its inputs change
	const ModalDashboard = useCallback(() => {
		if (!parentModalDashboardSetting && !isEmpty(modalDashboardSetting))
			return (
				<Dialog
					sx={{
						'& .MuiDialogContent-root': {
							padding: '0 !important',
						},
					}}
					open={open}
					onClose={() => setOpen(false)}
					// fullWidth + maxWidth to let us control the paper size
					fullWidth
					// Make the paper wide (landscape) and give it a fixed-ish height
					PaperProps={{
						sx: {
							overflowY: 'unset',
							maxWidth: '90% !important',
							width: '95%',
							height: '80%',
							display: 'flex',
						},
					}}
				>
					<DialogContent>
						<ModalDashboardLayoutContent
							passedIdValue={passedIdValue}
							modalDashboardSetting={modalDashboardSetting}
						/>
					</DialogContent>
					<DialogActions>
						<IconButton
							sx={{
								position: 'absolute',
								left: '98.5%',
								top: '-3%',
								backgroundColor: '#ffffff',
								border: '2px solid',
								borderColor: 'lightgray',
								'&:hover': { backgroundColor: '#ffffff' },
							}}
							onClick={(e) => setOpen(false)}
							alignItems="flex-end"
							size="small"
						>
							<CloseIcon />
						</IconButton>
					</DialogActions>
				</Dialog>
			)

		return null
	}, [open, passedIdValue, modalDashboardSetting, parentModalDashboardSetting])

	return {
		handleOpenModalDashboardDialog,
		handleCloseModalDashboardDialog,
		ModalDashboard,
	}
}
